import { render, staticRenderFns } from "./GaugeDevicePanel.vue?vue&type=template&id=35b79530&scoped=true&lang=pug&"
import script from "./GaugeDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./GaugeDevicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./GaugeDevicePanel.vue?vue&type=style&index=0&id=35b79530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b79530",
  null
  
)

export default component.exports